/**
 * Live URL Tracking filter constants — aligned with backend VALID_FILE_TYPES
 * and FILE_TYPE_FILTER_MAP in liveUrlTrackingService.js
 */
export const LIVE_URL_FILE_TYPE_OPTIONS = [
  { value: 'php', label: 'PHP' },
  { value: 'html', label: 'HTML' },
  { value: 'htm', label: 'HTM' },
  { value: 'css', label: 'CSS' },
  { value: 'js', label: 'JS' },
  { value: 'mp3', label: 'MP3' },
  { value: 'mp4', label: 'MP4' },
  { value: 'pdf', label: 'PDF' },
  { value: 'doc', label: 'DOC' },
  { value: 'xlsx', label: 'XLSX' },
  { value: 'txt', label: 'TXT' },
  { value: 'other', label: 'Other' },
  { value: 'unlisted', label: 'Unlisted' }
];

/** Root folder entries excluded from Live URL Tracking folder filters */
export const EXCLUDED_ROOT_FOLDER_NAMES = new Set(['1']);

/**
 * @param {Array<string|{ directory: string }>} raw
 * @returns {string[]}
 */
export const normalizeRootFolderOptions = (raw) => {
  if (!Array.isArray(raw)) return [];

  return raw
    .map((item) => {
      if (typeof item === 'string') {
        return item;
      }
      if (item && typeof item.directory === 'string') {
        return item.directory;
      }
      return null;
    })
    .filter(Boolean)
    .filter((name) => !EXCLUDED_ROOT_FOLDER_NAMES.has(name));
};
